import type { GetServerSidePropsContext, NextPageContext } from 'next'
import type { NextRouter } from 'next/router'
import { getUserAttributes as sharedGetUserAttributes } from '@mc/next-user-attributes'
import { getMcUserIdFromCtx } from './getMcUserIdFromCtx'

type Router = Pick<NextRouter, 'query'>
type Context = Pick<
  GetServerSidePropsContext | NextPageContext,
  'req' | 'res' | 'query'
>

/**
 * jarvis-vision's userAttributes for GrowthBook. Wraps the shared
 * getUserAttributes, sets `platform_name` to `educator`, and adds `mcUserId`
 * decoded from the executive access token JWT.
 *
 * Executive auth is server-to-server proxied through Next.js, so Rails'
 * canonical_id cookie never reaches the browser — `userId` ends up as a
 * transient anon ID and force rules targeting it are unreliable. mcUserId
 * is the integer DB user ID, stable across devices/sessions.
 */
export const getUserAttributes = async (ctx: Context, router: Router) => {
  const base = {
    ...sharedGetUserAttributes(ctx, router),
    platform_name: 'educator',
  }
  const mcUserId = await getMcUserIdFromCtx(ctx)
  return mcUserId ? { ...base, mcUserId } : base
}
